
<span role="none" class="clickable" (click)="showEmployee()"> 
        <ng-content></ng-content>
</span>

